import classNames from "classnames";
import { RenderElementProps, useFocused, useSelected } from "slate-react";
import { TimeEntryDescription } from "./types";

export interface RenderTimeDescriptionElementProps extends RenderElementProps {
  element: TimeEntryDescription;
}
export const RenderTimeDescriptionElement = ({
  children,
  attributes,
}: RenderTimeDescriptionElementProps) => {
  const selected = useSelected();
  const focused = useFocused();
  return (
    <div
      className={classNames(
        "mr-8 rounded-sm px-2 current-entry-hover:bg-gray-400/5 current-entry-hover:hover:bg-gray-800/5",
        { "bg-gray-800/5": selected && focused }
      )}
      {...attributes}
    >
      {children}
    </div>
  );
};
